import { render } from "./NIcon.vue?vue&type=template&id=2f0530f5&ts=true"
import script from "./NIcon.vue?vue&type=script&lang=ts"
export * from "./NIcon.vue?vue&type=script&lang=ts"

import "./NIcon.vue?vue&type=style&index=0&id=2f0530f5&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__